import { apiGetCasino, apiGetOffers, apiGetCasinoFeed } from '@/api';
import * as types from '@/store/mutation-types';

// Models
import CASINO from '@/store/models/casino';

// initial state
const state = {
  isLoading: true,
  // userLocation: serverData.userLocation,
  userLocation: 'global',
  s3: Laravel.mapBaseUrl,

  dialog: {
    isPeaking: false,
    isOverlay: false,
    isActive: false,

    casino: CASINO,

    casinoOffers: [],
    casinoStatus: []
  }
};

// mutations
const mutations = {
  [types.SET_LOADING] (state, bool) {
    state.isLoading = bool;
  },

  [types.SET_DIALOG_ACTIVE] (state, bool) {
    state.dialog.isActive = bool;
  },

  [types.SET_DIALOG_PEAK] (state, bool) {
    state.dialog.isPeaking = bool;
  },

  [types.SET_DIALOG_OVERLAY] (state, bool) {
    state.dialog.isOverlay = bool;
  },

  [types.RECEIVED_DIALOG_CASINO] (state, data) {
    state.dialog.casino = data;
  },

  [types.RECEIVED_DIALOG_CASINO_OFFERS] (state, data) {
    state.dialog.casinoOffers = data.data;
  },

  [types.RECEIVED_DIALOG_CASINO_STATUS] (state, data) {
    state.dialog.casinoStatus = data.data;
  }
};

const actions = {
  setLoading: ({ commit }, bool) => {
    commit(types.SET_LOADING, bool);
  },

  showDialogOverlay: ({ commit }) => {
    commit(types.SET_DIALOG_PEAK, false);
    commit(types.SET_DIALOG_OVERLAY, true);
  },

  hideDialogOverlay: ({ commit }) => {
    commit(types.SET_DIALOG_OVERLAY, false);
  },

  showDialogPeaking: ({ commit }) => {
    commit(types.SET_DIALOG_PEAK, true);
  },

  hideDialogPeaking: ({ commit }) => {
    commit(types.SET_DIALOG_PEAK, false);
  },

  setDialogActive: ({ commit }, bool) => {
    commit(types.SET_DIALOG_ACTIVE, bool);
  },

  getDialogCasino: ({ commit }, slug) => {
    apiGetCasino(slug).then(({ data }) => {
      commit(types.RECEIVED_DIALOG_CASINO, data);
    })
    .catch((error) => {
      console.log(error);
    });
  },

  getDialogOffers: ({ commit }, slug) => {
    apiGetOffers({ 
      casino_slug: slug, 
      limit: 2
    })
    .then(({ data }) => {
      commit(types.RECEIVED_DIALOG_CASINO_OFFERS, data);
    })
    .catch((error) => {
      console.log(error);
    });
  },

  getDialogCasinoStatuses: ({ commit }, slug) => {
    apiGetCasinoFeed(slug, { 
      types: [{type: 'status'}],
      limit: 1
    })
    .then(({ data }) => {
      commit(types.RECEIVED_DIALOG_CASINO_STATUS, data);
    })
    .catch((error) => {
      console.log(error);
    });
  },
};

const getters = {
  map (state) {
    return state;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/map.js